import { useFormGeneratorHandleChangeV2 } from '../hooks/useFormGeneratorHandleChangeV2';
import { local_storage_utils } from '../utils/frfr-webstorage-utils';
import FormGenerator from './FormGenerator';
import Btn from './Btn';
import { useEffect } from 'react';
import config from '../utils/config';
import CardCollapsible from './CardCollapsible';


const definicija = [
  {
    "type": "input_radio_group",
    "params": {
      "label": "Kojem MES API-ju pristupate?",
      "name": "env_mes",
      "options": [
        { "title": "MES API PROD/pravi", "value": "PROD", "tooltip": "Koristi se zvanična PROD (Production) MES baza" },
        { "title": "MES API STG", "value": "STG", "tooltip": "Koristi se MES STG (Staging) baza" },
        { "title": "MES API test", "value": "TEST", "tooltip": "Koristi se MES test baza" },
      ]
    }
  },
  {
    "type": "input_radio_group",
    "params": {
      "label": "Koju bazu sastavljača upotrebljavamo?",
      "name": "env_backend",
      "options": [
        { "title": "Redovni backend i baza", "value": "REAL", "tooltip": "Koristi se realni backend i baza" },
        { "title": "Baza simulirana 01 (samo za developere)", "value": "SIM", "tooltip": "Koristi se simulirani backend i baza" },
      ]
    }
  },
];


const TerFormSettingsInitial = (props) => {
  let initialState = {
    env_mes: "TEST",
    env_backend: "REAL", // "REAL" je default a "SIM" za developere samo
    // env_mes_test: true,
    // env_backend_sim: true
  };

  const { state, handleChange, setState, errors, setErrors } = useFormGeneratorHandleChangeV2(initialState, {}, null);

  useEffect(() => {
    // load settings from localstorage
    local_storage_utils.item_get("satavljac_env_mes")
      .then((_local_env_mes) => {
        if (_local_env_mes === "TEST" || _local_env_mes === "PROD" || _local_env_mes === "STG") {
          setState(state => {
            return {
              ...state,
              env_mes: _local_env_mes
            }
          });
        }
      })

    local_storage_utils.item_get("satavljac_env_backend")
      .then((_local_env_backend) => {
        if (_local_env_backend === "SIM" || _local_env_backend === "REAL") {
          setState(state => {
            return {
              ...state,
              env_backend: _local_env_backend
            }
          });
        }
      })

  }, []);

  const config_detected_env = config.detected_env;
  useEffect(() => {
    if (config_detected_env === 'LOCALHOST_DEV') {
      document.body.classList.add("env-is-local-dev");
    } else if (config_detected_env === 'PROD') {
      document.body.classList.add("env-is-prod");
    } else if (config_detected_env === 'STG') {
      document.body.classList.add("env-is-testing", "env-is-stg");
    } else {
      document.body.classList.add("env-is-testing", "env-is-dev");
    }
  }, [config_detected_env]);

  const _click = () => {
    // click na SUBMIT taster
    if (typeof props.cb === 'function') {
      // save settings to localstorage
      local_storage_utils.item_set("satavljac_env_mes", state.env_mes);
      local_storage_utils.item_set("satavljac_env_backend", state.env_backend);
      //
      props.cb(state);
    }
  }


  return (
    <>
      <h2>SASTAVLJAČ Podešavanja pred pokretanje</h2>
      <p>Detektovano okruženje <b>{config.detected_env}</b></p>
      <FormGenerator
        formDefinition={definicija}
        formState={state}
        formErrors={errors}
        handleChange={handleChange}
        extraClass={"temp-fields-with-no-margins"}
      />
      <div className="unicompo-dialog__btns">
        <Btn 
        title='Pokreni aplikaciju' 
        handleClick={_click} 
        i='fa fa-play-circle'
        />
      </div>
      <div className="unicompo-dialog__btns">
        <CardCollapsible title="Prikaži raspoloživa okruženja" full>
          <p>Na raspolaganju su sledeća okruženja:</p>
          <p><a href="http://172.16.10.95:5050">172.16.10.95:5050</a> <b>PROD</b> - Production (<b>Zvanična aplikacija</b>)<br />
            <a href="http://172.16.10.95:5058">172.16.10.95:5058</a> <b>STG</b> - Staging (<b>za testiranje</b>)<br />
            <a href="http://172.16.10.95:5059">172.16.10.95:5059</a> <b>DEV</b> (najnovija developerska verzija za testiranje)</p>
        </CardCollapsible>
      </div>
      <div className="unicompo-dialog__btns">
        <div>Da biste pravilno učitali najnoviju verziju aplikacije, na tastaturi, pritisnite <br />kombinaciju tastera <kbd>Ctrl</kbd> + <kbd>F5</kbd>. Ako koristite browser "Mozilla Firefox", <br />možete kliknuti na&nbsp;&nbsp;<Btn
          btnMedium
          inline
          outline
          circle
          extraClass=""
          i='fa fa-refresh'
          title='Osveži forsirano'
          handleClick={() => {
            // browser_utils.browser_refresh_forced()
            // Reload the current page from the server, ignoring the browser cache.
            window.location.reload(true);
          }}
        /></div>
      </div>
    </>
  );
};

export default TerFormSettingsInitial;